import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { Checkbox } from "components/Form/SpecialButtons";

const GeneralForm = () => (
	<div>
		<Field type="text" name="label" customlabel="Libellé du code tube" component={CustomInputTextComponent} required />
		<Field type="text" name="code" customlabel="Code Tube" component={CustomInputTextComponent} required />
		<Field type="text" name="sil_code" customlabel="Code SIL" component={CustomInputTextComponent} required />
		<Field type="text" name="comment" customlabel="Commentaire" component={CustomInputTextComponent} />
		<Field type="text" name="group" customlabel="Regroupement" component={CustomInputTextComponent} />
		<Field type="number" name="timer" customlabel="Temps d'attente avant le prélévement de ce tube" component={CustomInputTextComponent} />
		<Field
			type="number"
			name="timer_before_result"
			customlabel="Test rapide - Temps d'attente avant de connaitre le résultat"
			component={CustomInputTextComponent}
		/>
		<Field type="number" name="volume" customlabel="Volume" component={CustomInputTextComponent} />
		<Field type="text" name="regex" customlabel="Règle de validation du code-barres" component={CustomInputTextComponent} />
		<Field name="to_package" customlabel="A coliser" component={Checkbox} required />
	</div>
);

export default GeneralForm;
